<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.premium="{item}">
        <div align="center">{{ item.premium ? "ON" : "OFF" }}</div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item, index}">
        <v-icon @click="row_update(item, index)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_moveup(item, index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item, index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item, index)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-flash-ad-config-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {FlashAdConfig} from "@/modules/redactor/models/smart-offer/bundle-flash-ad/FlashAdConfig";
import RFlashAdConfigDialog from "@/modules/redactor/views/smart-offer/bundle-flash-ad/r-flash-ad-config-dialog.vue";

export default {
  name: "r-flash-ad-config-table",
  components: {RFlashAdConfigDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(FlashAdConfig).isRequired,
    toolbar: VueTypes.bool.def(true),
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: 'Key', value: 'key'},
      {text: 'Group', value: 'group'},
      {text: 'Priority', value: 'priority'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if (this.row_duplicate(data, -1)) {
              this.$alert("Duplicate found!");
            } else {
              this.items.push(data);
            }
          }).catch(() => {
      });
    },
    row_update(item, index) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            if (this.row_duplicate(data, index)) {
              this.$alert("Duplicate found!");
            } else if (index === this.items.indexOf(item)) {
              this.items.splice(index, 1, data);
            }
          }).catch(() => {
      });
    },
    row_remove(item, index) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        if (this.items.indexOf(item) === index) {
          this.items.splice(index, 1);
        }
      });
    },
    row_moveup(item, index) {
      if (index > 0 && this.items.indexOf(item) === index) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item, index) {
      if (index < this.items.length - 1 && this.items.indexOf(item) === index) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },
    row_duplicate(item, index) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].key === item.key && i !== index) {
          return true;
        }
      }
      return false;
    }
  }
}
</script>